import axios from 'axios';

import PartnersEditar from '../types/PartnersEditar';


async function GuardarPartner(prmPartner: PartnersEditar) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/guardar_partner"
    
    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "partner": {
                "id": prmPartner.id,
                "cuit": prmPartner.cuit,
                "razonsocial": prmPartner.razonsocial,
                "domicilio": prmPartner.domicilio,
                "telefono": prmPartner.telefono,
                "whatsapp": prmPartner.whatsapp,
                "web": prmPartner.web,
                "habilitado": prmPartner.habilitado,
                "mostrar_web": prmPartner.mostrar_web,
                "fchalta": prmPartner.fchalta,
                "fchmodificado": prmPartner.fchmodificado,
                "dado_baja": prmPartner.dado_baja,
                "fchbaja": prmPartner.fchbaja,
                "logo_mime": prmPartner.logo_mime,
                "logo_content": prmPartner.logo_content,
                "logo_name": prmPartner.logo_name
            }
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export default GuardarPartner;